export const FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_SUCCESS = 'FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_SUCCESS';

export const findProcessStatementCommentVisibilitySuccess = ({ year, modules }) => ({
    type: FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_SUCCESS,
    payload: { year, modules },
});
